import { INVENTORY_TABLE_EVENT_TYPE_SORT, ORDER_BY } from "../constants";

export const getOrderType = (type, sortOrder, params) => {
  if(type === INVENTORY_TABLE_EVENT_TYPE_SORT){
    return sortOrder === ORDER_BY.desc ? ORDER_BY.asc : ORDER_BY.desc
  }
    return params.orderType

}